const { dataLayerListener } = require('./data-layer.cjs');
const { serverGtm } = require('./gtm.cjs');

const {
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent,
    ytmAndVarioqub
} = require('./ytm.cjs');

const { alfaPartners } = require('./partners.cjs');

const { varioqubAntiFlicker, antiFlicker, alfaMessage } = require('./anti-flickers.cjs');

const { platformIdReady } = require('./platform-id-ready.cjs');

const getCounters = (url, data) => {
    const { CUSTOM_PARTNER_YTM_ID, CUSTOM_ALFA_YTM_ID, CUSTOM_YTM_ID, ENABLE_COUNTERS } =
        process.env;
    const { pageContent: { webAnalytics } = {} } = data;
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const enableYtm =
        isCountersEnabled && CUSTOM_YTM_ID && CUSTOM_PARTNER_YTM_ID && CUSTOM_ALFA_YTM_ID;
    const ytmScripts = [
        ytmNoScript(),
        ytmCookie,
        dataLayerListener,
        ytmSendUserParams(),
        ytmSendEvent(webAnalytics)
    ];

    const headAntiFlicker = isCountersEnabled ? varioqubAntiFlicker() : '';

    const headYTM = enableYtm ? ytmAndVarioqub(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
        headCounters: [platformIdReady, headAntiFlicker, headYTM],
        bodyCounters: [bodyYTM, isCountersEnabled ? alfaPartners(url) : ''],
        endBodyCounters: []
    };
};

module.exports = {
    getCounters,
    serverGtm,
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent,
    ytmAndVarioqub,
    alfaPartners,
    varioqubAntiFlicker,
    antiFlicker,
    alfaMessage,
    platformIdReady
};
